import { a as attr } from "../../../../../chunks/attributes.js";
import { E as Editor } from "../../../../../chunks/Editor.js";
function _page($$renderer, $$props) {
  $$renderer.component(($$renderer2) => {
    const { data } = $$props;
    const alert = data.alert;
    let visible = alert.visible;
    let content = alert.content || { time: Date.now(), blocks: [] };
    let $$settled = true;
    let $$inner_renderer;
    function $$render_inner($$renderer3) {
      $$renderer3.push(`<h1 class="heading">Komunikat</h1> <form class="form-group"><div><label>Komunikat widoczny <input type="checkbox"${attr("checked", visible, true)}/></label></div> <div>`);
      Editor($$renderer3, {
        get value() {
          return content;
        },
        set value($$value) {
          content = $$value;
          $$settled = false;
        }
      });
      $$renderer3.push(`<!----></div> <div><button type="submit" class="btn">Zapisz</button></div></form>`);
    }
    do {
      $$settled = true;
      $$inner_renderer = $$renderer2.copy();
      $$render_inner($$inner_renderer);
    } while (!$$settled);
    $$renderer2.subsume($$inner_renderer);
  });
}
export {
  _page as default
};
